.loginContainer {
  background-color: #F8FAFC;
  padding: 0.6rem;
  border-radius: 0.5rem;
  width: 26%;
  min-width: 400px;
  max-width: 525px;
  margin: auto;

  @media (max-width: 440px) {
    min-width: calc(100% - 4.2rem);
  }

  @media (max-width: 800px) {
    width: 100%;
  }

  .pageLevelNotificationWrapper {
    margin: 1rem 0rem;
    padding: 0.1rem;

    >span:first-child {
      padding-right: 0rem;
    }

    >span:nth-child(2) {
      padding-left: 0rem;

      >p {
        margin: 0rem !important;
      }
    }

    >span {
      padding: 0.5rem;
    }
  }

  >button:nth-child(2) {
    margin-bottom: 1rem;
    width: 130px;
  }

  +p {
    margin: 1rem auto;
    font-weight: 550;
    width: 30%;

    @media (max-width: 800px) {
      width: 100%;
    }

    +p {
      margin: auto;
      font-weight: 550;
      width: 30%;

      @media (max-width: 800px) {
        width: 100%;
      }
    }
  }
}